import React from "react";
import Layout from "../../reusables/layout/layout";
import Login from "../../Component/loginform/login";

const PaymentLoginModel = () => {

  return (
    <div>
      <Layout>
        <Login
          examType={"MODEL SCREENING EXAMINATION"}
          url={"/individual/login/01"}
          navigateTo={"/requisition/model"}
          homeLink={"https://screeningtest.examsboard.lagosstate.gov.ng/"}
        />
      </Layout>
    </div>
  );
};

export default PaymentLoginModel;
